// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7668":"62a14f78","9833":"fa12ab78"}[chunkId] + ".chunk.css";
};